import React from 'react';
import styled from 'styled-components';

import { Display } from '@rover/kibble/core';
import { Props as DisplayProps } from '@rover/kibble/core/Display';
import MQ from '@rover/kibble/styles/MediaQuery';
import useTheme from '@rover/kibble/themes/useTheme';
import LinkOrganizer from '@rover/react-lib/src/components/lists/LinkOrganizer';
import { ServiceLinkWithName } from '@rover/react-lib/src/redux/ducks/serviceLinks.duck';
import type { Anchor } from '@rover/types/src/Anchor';
import { ServiceLandingEnum } from '@rover/types/src/ServiceLanding';

type Props = {
  serviceLandingType: ServiceLandingEnum | null;
  serviceLinksWithDisplayName: ServiceLinkWithName[];
  children?: React.ReactNode;
  columnGap?: string;
};

const StyledLinkOrganizer = styled(LinkOrganizer)`
  ${MQ.XS_DOWN.toString()} {
    column-gap: 16px;
  }

  ${MQ.SM_DOWN.toString()} {
    column-gap: 24px;
  }

  & > li {
    ${MQ.XS_DOWN.toString()} {
      line-height: 200%;
      margin-bottom: -0.5em;
    }
  }
`;

const ServiceLandingServices = ({
  serviceLinksWithDisplayName,
  serviceLandingType,
  children,
  columnGap,
}: Props): JSX.Element => {
  const { sizes } = useTheme();
  const serviceLinkAnchors = serviceLinksWithDisplayName
    .filter(({ type }) => type !== serviceLandingType)
    .map(({ href, name }): Anchor => ({ title: name, href: href || '' }))
    .sort((a, b) => a.title.localeCompare(b.title));

  return (
    <>
      {children}
      <StyledLinkOrganizer
        links={serviceLinkAnchors}
        columns={[2, 3, serviceLinkAnchors.length === 13 ? 3 : 4]}
        columnGap={columnGap || sizes['2x']}
        lineSpacing="large"
      />
    </>
  );
};

ServiceLandingServices.Display = (props: DisplayProps): JSX.Element => (
  <Display
    marginTop="3x"
    marginBottom="2x"
    size="500"
    webProps={{ responsive: false }}
    textAlign="center"
    {...props}
  >
    {props.children}
  </Display>
);

export default ServiceLandingServices;
